// extracted by mini-css-extract-plugin
export var alignCenter = "_90-d";
export var bannerShown = "_90-6";
export var buttonContent = "_90-0";
export var cardList = "_90-1";
export var centerContent = "_90-2";
export var chevron = "_90-3";
export var closePanelButton = "_90-k";
export var conversationContextContainer = "_90-l";
export var conversationDetailContainer = "_90-4";
export var detailWrapper = "_90-7";
export var dropdownButton = "_90-e";
export var dropdownTitle = "_90-9";
export var fullHeight = "_90-5";
export var hidden = "_90-a";
export var icon = "_90-b";
export var mergeSuggestionWrapper = "_90-m";
export var panel = "_90-i";
export var portalButtonsWrapper = "_90-c";
export var right = "_90-j";
export var tableSummaryContainer = "_90-8";
export var tableSummaryHeader = "_90-g";
export var threeDotsButton = "_90-f";
export var wide = "_90-h";